import { useEffect, useState } from 'react';
import { api } from './api';

interface Branding {
  nameTh: string;
  logoDataUri: string | null;
}

/**
 * ชื่อและโลโก้มูลนิธิสำหรับใช้ทั่วเว็บ
 *
 * cache ไว้ในตัวแปรระดับโมดูล เพราะทุกหน้าที่ render Shell จะเรียกซ้ำ
 * และค่าพวกนี้แทบไม่เปลี่ยน — ไม่ควรยิง API ทุกครั้งที่เปลี่ยนหน้า
 */
let cached: Branding | null = null;
let inflight: Promise<Branding> | null = null;

async function load(): Promise<Branding> {
  if (cached) return cached;
  if (!inflight) {
    inflight = Promise.all([
      api<{ nameTh: string }>('/settings/org').catch(() => ({ nameTh: '' })),
      api<{ dataUri: string | null }>('/settings/logo').catch(() => ({ dataUri: null })),
    ])
      .then(([org, logo]) => {
        cached = { nameTh: org.nameTh, logoDataUri: logo.dataUri };
        return cached;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

/** เรียกหลังบันทึกที่หน้าตั้งค่า เพื่อให้แถบด้านข้างเปลี่ยนตามทันที */
export function invalidateBranding(): void {
  cached = null;
}

export function useBranding(): Branding {
  const [branding, setBranding] = useState<Branding>(cached ?? { nameTh: '', logoDataUri: null });

  useEffect(() => {
    let cancelled = false;
    void load().then((b) => {
      if (!cancelled) setBranding(b);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return branding;
}
